/* app/js/src/components/videoPreview/videoPreview.component.scss */
.cursor-pointer {
  cursor: pointer;
}
video-container {
  -webkit-flex: 2 0 0;
  -ms-flex: 2 0 0;
  flex: 2 0 0;
  position: relative;
  height: 250px;
}
.container {
  width: 342px;
  height: 235px;
  position: fixed;
  right: 50%;
  bottom: 55%;
  background-color: #ffffff;
  z-index: 10;
  transition: opacity ease-in 0.2s;
  -webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
}
.container.show {
  opacity: 1;
  pointer-events: initial;
}
.container header {
  height: 43px;
}
.container header .topHeader {
  height: 24px;
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  position: relative;
  padding: 6px;
  line-height: 12px;
  background-color: #141b22;
  cursor: all-scroll;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .topHeader .icons {
  position: absolute;
  right: 6px;
  top: 6px;
  font-size: 0;
  z-index: 3;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .topHeader .icons .close {
  display: inline-block;
  cursor: pointer;
}
.container header .topHeader .icons .close svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.container header .topHeader .icons .close svg:hover path {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
.container header .topHeader .icons .enlarge {
  display: inline-block;
  cursor: pointer;
  margin-right: 9px;
}
.container header .topHeader.active::before {
  content: " ";
  background-color: transparent;
  position: absolute;
  left: -100%;
  top: -300%;
  width: 300%;
  height: 1600%;
  z-index: 3;
}
.container header .bottomHeader {
  height: 19px;
  font-size: 10px;
  color: #ffffff;
  position: relative;
  padding: 4.5px 6px;
  background-color: #232f3a;
  line-height: 9px;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .bottomHeader .time {
  position: absolute;
  right: 6px;
  top: 6px;
  cursor: default;
  opacity: 0;
}
.container section {
  height: 192px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container section video {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
}
.fullscreen-container {
  display: flex;
}
/*# sourceMappingURL=videoPreview.component.css.map */
